import { request } from '@/api/client';
import type { TaxonomyItem } from '@/types/echo_creation';

/** Echo taxonomy lookups — domains and categories used in create/edit forms. */
export const taxonomyService = {
  getDomains: (): Promise<TaxonomyItem[]> =>
    request<TaxonomyItem[]>('/echoes/domains', { method: 'GET' }),

  getCategories: (): Promise<TaxonomyItem[]> =>
    request<TaxonomyItem[]>('/echoes/categories', { method: 'GET' }),
};
